import React from 'react';

export const ArrowLeftGray300Icon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M6.86194 2.86152C7.12217 2.60141 7.54398 2.60159 7.80432 2.86152C8.06467 3.12187 8.06467 3.54453 7.80432 3.80488L4.27698 7.3332H14.6666C15.0348 7.3332 15.3336 7.632 15.3336 8.00019C15.3334 8.36823 15.0347 8.66621 14.6666 8.66621H4.276L7.80432 12.1955C8.06467 12.4559 8.06467 12.8775 7.80432 13.1379C7.54395 13.398 7.12222 13.3982 6.86194 13.1379L1.72424 8.00019L6.86194 2.86152Z"
        fill="#DCDCDC"
      />
    </svg>
  );
};
